<button *ngIf="form && checkComponent()" matTooltip="Annulla" type="button"
class="my-bounce btn closeRequestButton mx-2" (click)="openModal()">
{{ 'REQUEST.annullaRichiesta' | translate }}
</button>